import { useI18n } from '@ecom/i18n';
import { Field } from '@ecom/ui-kit';
import { type ReactElement, useState } from 'react';

/** The minimum the API accepts for the stated reason (`reissueStaffPasswordSchema`). */
export const REISSUE_REASON_MIN_LENGTH = 10;

export function ReissuePasswordForm({
  onSubmit,
  formId,
  disabled,
}: {
  onSubmit: (reason: string) => void;
  formId: string;
  disabled: boolean;
}): ReactElement {
  const { t } = useI18n();
  const [reason, setReason] = useState('');

  return (
    <form
      id={formId}
      noValidate
      className="flex flex-col gap-4"
      onSubmit={(event) => {
        event.preventDefault();
        if (reason.trim().length >= REISSUE_REASON_MIN_LENGTH && !disabled) onSubmit(reason.trim());
      }}
    >
      <p className="text-sm text-inkSoft">{t('merchant.staff.reissueIntro')}</p>
      <Field label={t('merchant.staff.reissueReason')}>
        {(bind) => (
          <textarea
            {...bind}
            rows={3}
            maxLength={500}
            value={reason}
            disabled={disabled}
            className="ecom-input"
            onChange={(event) => {
              setReason(event.target.value);
            }}
          />
        )}
      </Field>
    </form>
  );
}
